/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FeatureCollection } from "geojson";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

interface ObterAreasEspeciaisGeoRequest {
  onSuccess?: (result: FeatureCollection) => void;
}

interface State {
  isRequesting: boolean;
  // Ver a nota em obterZonasGeo: serve de `key` para remontar a camada.
  requestNumber: string;
  successPayload: FeatureCollection | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  requestNumber: String(Math.random()),
  successPayload: null,
  errors: []
};

const obterAreasEspeciaisGeoSlice = createSlice({
  name: "consultaprevia@obterAreasEspeciaisGeo",
  initialState,
  reducers: {
    obterAreasEspeciaisGeo: (
      state,
      action: PayloadAction<ObterAreasEspeciaisGeoRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterAreasEspeciaisGeoSuccess: (
      state,
      action: PayloadAction<FeatureCollection>
    ): void => {
      state.requestNumber = String(Math.random());
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterAreasEspeciaisGeoFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: ObterAreasEspeciaisGeoRequest;
}) {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/consulta-previa/areas-especiais/geo`
    );

    const { data }: { data: FeatureCollection } = response;

    if (params.payload?.onSuccess) params.payload.onSuccess(data);

    yield put(obterAreasEspeciaisGeoSuccess(data));
  } catch (error) {
    yield put(obterAreasEspeciaisGeoFailed(formatError(error)));
  }
}

export const {
  obterAreasEspeciaisGeo,
  obterAreasEspeciaisGeoSuccess,
  obterAreasEspeciaisGeoFailed
} = obterAreasEspeciaisGeoSlice.actions;
export const { reducer } = obterAreasEspeciaisGeoSlice;
export const saga = takeLatest(obterAreasEspeciaisGeo.type, sagaFunction);
